module.exports = __webpack_public_path__ + "img/Suv_Back_Side_Right.ea0e8d28.svg";